import type {ChangeStyleTheme, RequestConfig} from '@Components/ai-chat-window/ai-chat-window.types';
import {TextPartPurpose} from '@Components/ai-chat-window/ai-chat-window.types';
import {buildChangeStyleRequestConfig, getChangeStyleThemePrompt} from '@Components/ai-chat-window/components/change-style-dropdown/change-style-dropdown.library';
import {GA4EventName, GA4EventParamName} from '@Libraries/ga-events';
import {isSmallScreenDropdown} from '@Components/dropdown-v2/dropdown.helper';
import {closeAllModals} from '@Components/modal-container/modal-container-reducer';
import type {AiPromptBoxAttachments} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import {PromptAttachmentType} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import {useAppDispatch} from '@/hooks';

interface UseChangeStyleThemeSelectParams {
  onGenerate: (prompt: string, promptAttachments?: AiPromptBoxAttachments, requestConfig?: RequestConfig, purpose?: TextPartPurpose) => Promise<void>;
  imageHashedId: string;
  imageWidth?: number;
  imageHeight?: number;
}

interface UseChangeStyleThemeSelectReturn {
  onThemeSelect: (theme: ChangeStyleTheme) => void;
}

export function useChangeStyleThemeSelect({onGenerate, imageHashedId, imageWidth, imageHeight}: UseChangeStyleThemeSelectParams): UseChangeStyleThemeSelectReturn {
  const dispatch = useAppDispatch();

  const onThemeSelect = (theme: ChangeStyleTheme): void => {
    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_EDIT, {[GA4EventParamName.TYPE]: theme});
    const requestConfig = buildChangeStyleRequestConfig(theme, imageWidth, imageHeight);

    if (isSmallScreenDropdown()) {
      dispatch(closeAllModals());
    }

    const attachments: AiPromptBoxAttachments = {
      items: [{type: PromptAttachmentType.REATTACHED_MODEL_IMAGE, imageHashedId}],
      dropdown: [],
    };
    void onGenerate(getChangeStyleThemePrompt(theme), attachments, requestConfig, TextPartPurpose.CHANGE_STYLE);
  };

  return {onThemeSelect};
}
